import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    repaymentTitle: {
        id: '_.outstanding_view.dashboardActionPanel.repaymentsTitle',
        defaultMessage: 'Your repayments over {monthsSchedule} months'
    },
    repaymentScheduleCTA: {
        id: '_.outstanding_view.dashboardActionPanel.repaymentsScheduleCTA',
        defaultMessage: 'See your new schedule'
    },
    minimumRepaymentsLabel: {
        id: '_.outstanding_view.dashboardActionPanel.minimumRepaymentsLabel',
        defaultMessage: 'Minimum monthly repayment'
    },
    minimumRepaymentsLabelInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.minimumRepaymentsLabelInterestOnly',
        defaultMessage: 'Minimum monthly payment (from the 4th month)'
    },
    minimumRepaymentsSubLabelInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.minimumRepaymentsSubLabelInterestOnly',
        defaultMessage: '(Interest payments due from the 1st month)'
    },
    totalInterestLabel: {
        id: '_.outstanding_view.dashboardActionPanel.totalInterestLabel',
        defaultMessage: 'Total interest'
    },
    feesLabel: {
        id: '_.outstanding_view.dashboardActionPanel.feesLabel',
        defaultMessage: 'Fees'
    },
    totalRepaymentLabel: {
        id: '_.outstanding_view.dashboardActionPanel.totalRepaymentLabel',
        defaultMessage: 'Total repayment'
    }
});
